import { render } from "./client_applications.html?vue&type=template&id=c3507c36&external"
import script from "./client_applications.js?vue&type=script&lang=js&external"
export * from "./client_applications.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__